import { Card } from "react-bootstrap";
import { Button } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.css";
import "react-multi-carousel/lib/styles.css";
import React from "react";
export function ProductCard({ id, image, title, description, netWeight, grossWeight, discPrice, price, isLoggedin, getItemQuantity, increaseCartQuantity, decreaseCartQuantity, removeFromCart, setNotLoggedinPopup }) {
    const quantity = getItemQuantity(id);
    const CURRENCY_FORMATTER = new Intl.NumberFormat(undefined, {
        currency: "INR",
        style: "currency"
    });
    function formatCurrency(number) {
        return CURRENCY_FORMATTER.format(number);
    }
    const checkLoginIncreaseQuantity = (id) => {
        if (isLoggedin) {
            increaseCartQuantity(id);
        }
        else {
            setNotLoggedinPopup();
        }
    };
    return (React.createElement("div", { style: { height: "30rem" }, "data-testid": `test_${id}`, className: "py-4 px-2 align-items-center justify-content-center d-flex  " },
        React.createElement(Card, { key: id, "data-testid": `test_${id}`, className: "shadow-lg lh-1 px-1 pt-4 card m-2 h-100", style: {
                minWidth: "13rem",
                height: "28rem",
                maxHeight: "50rem",
                overflow: "hidden"
                //   boxShadow:
                //     "1.6px 1.6px 1.2px rgba(0, 0, 0, 0.015),  3.4px 3.4px 2.7px rgba(0, 0, 0, 0.022),  5.8px 5.8px 4.6px rgba(0, 0, 0, 0.027),  8.7px 8.7px 6.9px rgba(0, 0, 0, 0.031),  12.5px 12.5px 10px rgba(0, 0, 0, 0.035),  17.7px 17.7px 14.2px rgba(0, 0, 0, 0.039),  25.1px 25.1px 20.1px rgba(0, 0, 0, 0.043),  36.5px 36.5px 29.2px rgba(0, 0, 0, 0.048),  56.3px 56.3px 45px rgba(0, 0, 0, 0.055),  100px 100px 80px rgba(0, 0, 0, 0.07)"
            } },
            React.createElement(Card.Img, { variant: "top", src: image, className: "m-0 mx-auto p-0 img-fluid", style: {
                    objectFit: "cover",
                    width: "16rem",
                    height: "8rem",
                    borderRadius: "8px"
                } }),
            React.createElement(Card.Body, { className: "  p-0 m-0" },
                React.createElement(Card.Header, { className: "  m-0  justify-content-between font align-items-baseline ", style: { borderRadius: "10px" } },
                    React.createElement(Card.Title, { className: "mx-auto p-0 m-0" }, title.charAt(0).toUpperCase() + title.substring(1, 40)),
                    title.length < 22 ? React.createElement("br", null) : ""),
                React.createElement(Card.Text, { className: "text-center mb-0 pb-0 font " },
                    React.createElement("p", { className: "lh-1 pt-2 mb-0 pb-0 fw-light", style: { fontSize: "16px" } }, description.charAt(0).toUpperCase() + description.substring(1, 60)))),
            React.createElement(Card.Body, { className: "  pt-4 m-0 font" },
                React.createElement("p", { className: " ", style: { fontSize: "13px" } },
                    "Net. Wt.: " + netWeight + "gms",
                    " ",
                    "Gross Wt.: " + grossWeight + "gms"),
                React.createElement("p", { className: "mb-0 pb-0 font", style: { fontSize: "13px" } }, discPrice - price < 0 ? (React.createElement("span", null,
                    React.createElement("del", null,
                        "Price : ",
                        formatCurrency(price)),
                    " ",
                    React.createElement("br", null),
                    "Disc Price :",
                    formatCurrency(discPrice))) : (React.createElement("span", null,
                    "Price : ",
                    formatCurrency(price))))),
            React.createElement(Card.Body, { className: "d-flex p-0" },
                React.createElement("div", { className: "mt-auto w-100 py-4  " }, quantity === 0 || !isLoggedin ? (React.createElement(Button, { className: "  ", onClick: () => checkLoginIncreaseQuantity(id) }, "Add to Cart")) : (isLoggedin && (React.createElement(React.Fragment, null,
                    React.createElement("div", { className: "d-flex align-items-center flex-column", style: { gap: ".5rem" } },
                        React.createElement("div", { className: "d-flex align-items-center justify-content-center", style: { gap: "0.5rem" } },
                            React.createElement(Button, { variant: "danger", size: "sm", onClick: () => removeFromCart(id) }, "x"),
                            React.createElement(Button, { onClick: () => decreaseCartQuantity(id) }, "-"),
                            React.createElement("div", null,
                                React.createElement("span", { className: "fs-3" }, quantity),
                                "in cart"),
                            React.createElement(Button, { onClick: () => increaseCartQuantity(id) }, "+")))))))))));
}
